import {
    createDateFromStringReverse,
    createDateString,
} from 'src/app/controls/calendar/calendar.utils';
import { AccomInventory, InventoryDto } from 'src/app/model/deal.model';

export interface MealPlanWithPrice {
    mealPlanType: string;
    mealPlanId: number;
    sellingPrice: number;
    crossedPrice: number;
    crossedPercent: number;
    priceDifferenceWithCheapest: number;
}

export interface RoomWithCheapestMealPlan {
    roomName: string;
    roomId: number;
    isCurrentlyDisabled?: boolean;
    reasonForDisabled?: string;
    occupancyLimits: RoomOccupancyLimits;
    cheapestMealPlan: {
        mealPlanType: string;
        sellingPrice: number;
        crossedPrice: number;
        crossedPercent: number;
    };
}

export interface RoomOccupancyLimits {
    maxAdult: number;
    maxTeen: number;
    maxChild: number;
    maxInfant: number;
    maxGuestInclInfants: number;
    maxPaxNoInfants: number;
}

export const transformInventoryDto = (
    inventory: InventoryDto[]
): AccomInventory[] => {
    const result: AccomInventory[] = [];

    inventory.forEach((accomInventoryDto) => {
        const date = createDateFromStringReverse(accomInventoryDto.date);

        result.push({
            date,
            roomId: accomInventoryDto.roomId,
            dateAsString: createDateString(date),
            sellingPrice: accomInventoryDto.sellingPrice,
            crossedOutPrice: accomInventoryDto.crossedOutPrice,
            minLengthOfStay: accomInventoryDto.minLengthOfStay,
        });
    });

    return result;
};

export interface OccupancyIdDto {
    id: number;
}
